import React from "react";

type Props = {
  title: string;
  subTitle: string;
  pillLabel?: string;
};

function ProductTitle({ title, subTitle, pillLabel = "Features" }: Props) {
  return (
    <div className="mx-auto flex max-w-5xl flex-col items-center gap-5 px-4 text-center md:gap-6">
      {/* Pill */}
      <div
        className="inline-flex items-center gap-2 rounded-full p-[1px]"
        style={{
          background:
            "radial-gradient(61.36% 139.46% at 39% 31.82%, #FCFCFC 0%, #505050 69.63%)",
        }}
      >
        <div className="flex items-center rounded-full bg-[#0B0B0B] px-2.5 py-1 text-[12px] leading-[22px] tracking-[-0.03em] md:px-3 md:py-1.5 md:text-[13px]">
          {/* Sphere */}
          <div
            className="mr-2 h-3 w-3 flex-shrink-0 rounded-full"
            style={{
              background:
                "radial-gradient(58.33% 58.33% at 50% 41.67%, rgba(255, 255, 255, 0.9) 0%, #505050 87.43%)",
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
          />
          <span
            style={{
              background:
                "linear-gradient(135deg, #FCFCFC 0%, #A0A0A0 50%, #505050 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {pillLabel}
          </span>
        </div>
      </div>

      {/* Heading */}
      <h2
        className="font-dm text-[34px] leading-[1.08] tracking-[-0.05em] sm:text-[40px] md:text-[52px]"
        style={{
          background: "linear-gradient(180deg, #F8F8F8 0%, #E0E0E0 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        {title}
      </h2>

      {/* Subheading */}
      <p className="font-dm max-w-[680px] text-[15px] leading-[1.6] tracking-[-0.03em] text-zinc-300 sm:text-[16px] md:text-[18px]">
        {subTitle}
      </p>
    </div>
  );
}

export default ProductTitle;
